import { render, staticRenderFns } from "./vwelcome.vue?vue&type=template&id=2870f62d"
import script from "./vwelcome.vue?vue&type=script&lang=js"
export * from "./vwelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports